export const appointmentDateTimeSelection_style = {
  appointmentCardSx: {
    mt: 2,
    ml: 1.9,
    mr: 2.6,
  },
};
